import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CatFichaInmaterial } from '../../models/CatFichaInmaterial';
import { FichaInmaterialService } from '../../services/ficha-inmaterial.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-form-ficha-inmaterial',
  templateUrl: './form-ficha-inmaterial.component.html',
  styleUrls: ['./form-ficha-inmaterial.component.css']
})
export class FormFichaInmaterialComponent implements OnInit {

  catFichaInmaterial: CatFichaInmaterial = new CatFichaInmaterial();
  title: string ='Crear Ficha Patrimonio Inmaterial';
  Editor = ClassicEditor;
  
  //SELECTS Data:
  marcosTemporales =['SEMANAL','MENSUAL','ANUAL','CICLICO'];
  Temas = ['USOS SOCIALES, FESTIVIDAD','ORALIDAD','ARTES DEL ESPECTACULO','ARTESANIA','USOS NATURALES Y TRADICIONALES'];
  estadosActuales = ['PLENA VIGENCIA','EN PELIGRO DE DESAPARICIÓN','EN PELIGRO DE DESTRUCCIÓN'];
  trascendenciasCulturalesAlcances = ['LOCAL','REGIONAL','NACIONAL','INTERNACIONAL'];
  elementosProcesos = ['USOS SOCIALES, FESTIVIDAD','ARTES DEL ESPECTACULO','ARTESANIA','ORALIDAD','CONOCIMIENTO DE NATURALEZA Y UNIVERSO'];
  manifestacionesHerencia = ['PREHISPANICO','COLONIAL','REPUBLICANO','CONTEMPORANEO'];
  


  constructor(
    private catFichaInmaterialService: FichaInmaterialService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    //cargar los datos de la ficha invocada si existiera
    this.cargarCatFichaInmaterial();
    
  }

  //funcion de trae una Ficha: mediante: "activatedRoute"
  cargarCatFichaInmaterial(){
    this.activatedRoute.params.subscribe( params => {
      let id = params['id'];
      if (id) {
        this.catFichaInmaterialService.traerFichaInmaterial(id).subscribe( ficha => {
          this.catFichaInmaterial = ficha
        })
      }
    })
  }

  

  crearFichaInmaterial(){
    console.log(this.catFichaInmaterial);
    //
    this.catFichaInmaterialService.crearFichaInmaterial(this.catFichaInmaterial).subscribe(
      response => {
        this.router.navigate(['/manfinmateriales']);
        //implementar Alert2
      }
    )
  }

  actualizarFichaInmaterial(){
    this.catFichaInmaterialService.actualizarFichaInmaterial(this.catFichaInmaterial).subscribe(
      ficha => {
        this.router.navigate(['/manfinmateriales']);
        //implementar Sweet Alert 2
      }
    )

  }
}
